import React from 'react';
import { CONFIG } from '../data/config';
import { cuandoLlega, plata } from '../utils/format';
import { itemsDelCarrito, type Carrito } from '../utils/pedido';
import type { ProximaEntrega, Zona } from '../types/pedido';
interface Props {
  carrito: Carrito;
  total: number;
  zona: Zona | null;
  fueraDeZona: boolean;
  entrega: ProximaEntrega | null;
  puedeConfirmar: boolean;
  enviando: boolean;
  onConfirmar: () => void;
}
export function ResumenLateral({
  carrito,
  total,
  zona,
  fueraDeZona,
  entrega,
  puedeConfirmar,
  enviando,
  onConfirmar
}: Props) {
  const items = itemsDelCarrito(carrito);
  const falta = CONFIG.pedidoMinimo - total;
  return <aside className="sticky top-8 hidden rounded-card border border-line bg-surface p-5 shadow-card lg:block" data-id="element-128" data-mp="1xs1a13zesgpx">
      <h2 className="display display-tight mb-4 text-[17.5px]" data-id="element-129" data-mp="26qwh0iaa1uua">Tu pedido</h2>

      {items.length === 0 ? <p className="text-sm leading-snug text-ink-faint" data-id="element-130" data-mp="21s39d6ho8y21">
          Todavía no elegiste nada. Sumá bidones desde la lista y el total aparece acá.
        </p> : <ul className="mb-4 space-y-2 border-b border-line pb-4" data-id="element-131" data-mp="u1mpq8op26z2">
          {items.map(i => <li key={i.id} className="flex items-baseline justify-between gap-3 text-sm" data-id="element-132" data-mp="z06e0fqrfuul">
              <span className="min-w-0" data-id="element-133" data-mp="13ziywuy2mruj">
                <span className="font-mono font-semibold tnum text-ink-soft" data-id="element-134" data-mp="18x2epzaf3col">{i.cant}×</span> {i.nombre}
              </span>
              <span className="shrink-0 font-mono tnum text-ink-soft" data-id="element-135" data-mp="1cxcta0c9zbf2">{plata(i.sub)}</span>
            </li>)}
        </ul>}

      <div className="mb-4" data-id="element-136" data-mp="1huut918begax">
        <span className="block text-[11px] font-semibold uppercase tracking-[0.075em] text-ink-faint" data-id="element-137" data-mp="1mne6ty705bfq">Total</span>
        <strong className="block font-mono text-[28px] font-bold leading-tight tnum tracking-[-0.02em]" data-id="element-138" data-mp="1rnac00rfr8wv">
          {plata(total)}
        </strong>
      </div>

      {(zona || fueraDeZona) && <p className="mb-4 text-[13px] leading-snug text-ink-soft" data-id="element-139" data-mp="20mxeyqztcms1">
          {fueraDeZona ? 'Zona a coordinar: te escribimos para confirmar el día.' : `Entrega ${cuandoLlega(entrega)} en ${zona?.barrio}.`}
        </p>}

      <button type="button" onClick={onConfirmar} disabled={!puedeConfirmar || enviando} className="display-btn w-full rounded-field bg-accent px-5 py-3.5 text-[15.5px] text-accent-ink transition-[background-color,transform] duration-150 ease-soft hover:bg-accent-hover active:translate-y-px disabled:cursor-not-allowed disabled:bg-line-strong disabled:text-surface" data-id="element-140" data-mp="3sn5hxzapccq7">
        {enviando ? 'Enviando…' : 'Confirmar pedido'}
      </button>

      {CONFIG.pedidoMinimo > 0 && total > 0 && falta > 0 && <p className="mt-3 text-[13px] font-semibold text-warn" data-id="element-141" data-mp="p803d16512i5">Te faltan {plata(falta)} para llegar al mínimo.</p>}
    </aside>;
}